import React from 'react';
import PropTypes from 'prop-types';
import { Icon, IconArrowLeft, IconArrowRight } from '@flixbus/honeycomb-icons-react';
import styles from '../../../../node_modules/@flixbus/honeycomb/dist/scss/components/calendar.scss.js';
import HoneyBem from '../../../../packages/honey-bem/honey-bem.js';
import Button from '../../../button/button.js';
import Select from '../../../select/select.js';
import SelectOption from '../../../select/select-option/select-option.js';

// init css class
const bem = new HoneyBem('calendar-header', styles);
function HeaderCompact(_ref) {
  let {
    calendar,
    months,
    onPrev,
    hasPrev = true,
    hasNext = true,
    selected,
    onNext,
    onChangeDate,
    compactPrevButton,
    compactNextButton,
    compactSelect,
    id
  } = _ref;
  const onChangeHandler = e => {
    onChangeDate(new Date(e.target.value));
  };
  return /*#__PURE__*/React.createElement("div", {
    className: bem.b('compact')
  }, /*#__PURE__*/React.createElement(Button, Object.assign({
    appearance: "secondary",
    display: "square",
    id: "".concat(id, "-calendar-prev-button"),
    onClick: onPrev,
    disabled: hasPrev,
    "aria-controls": "".concat(id, "-grid")
  }, compactPrevButton), /*#__PURE__*/React.createElement(Icon, {
    InlineIcon: IconArrowLeft,
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(Select, Object.assign({
    extraClasses: bem.e('select'),
    id: "".concat(id, "-month-year-select"),
    value: new Date(selected.getFullYear(), selected.getMonth(), 1).toDateString(),
    onChange: onChangeHandler,
    "aria-controls": "".concat(id, "-grid")
  }, compactSelect), calendar === null || calendar === void 0 ? void 0 : calendar.months.map(_ref2 => {
    let {
      month,
      year
    } = _ref2;
    const dateString = new Date(year, month, 1).toDateString();
    return /*#__PURE__*/React.createElement(SelectOption, {
      key: dateString,
      value: dateString
    }, "".concat(months[month], " ").concat(year));
  })), /*#__PURE__*/React.createElement(Button, Object.assign({
    appearance: "secondary",
    display: "square",
    id: "".concat(id, "-calendar-next-button"),
    onClick: onNext,
    disabled: hasNext,
    "aria-controls": "".concat(id, "-grid")
  }, compactNextButton), /*#__PURE__*/React.createElement(Icon, {
    InlineIcon: IconArrowRight,
    "aria-hidden": "true"
  })));
}
HeaderCompact.propTypes = {
  calendar: PropTypes.shape({}).isRequired,
  id: PropTypes.string.isRequired,
  selected: PropTypes.instanceOf(Date).isRequired,
  months: PropTypes.arrayOf(PropTypes.string).isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onChangeDate: PropTypes.func.isRequired,
  hasPrev: PropTypes.bool,
  hasNext: PropTypes.bool,
  compactPrevButton: PropTypes.shape({}).isRequired,
  compactNextButton: PropTypes.shape({}).isRequired,
  compactSelect: PropTypes.shape({}).isRequired
};

export { HeaderCompact };
